import React from "react";
import GetInitials from "../GetInitials";
import { isEmpty } from "lodash";
import { fullName, ssnMasking } from "../../utils";
import AddToolTip from "../AddToolTip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";

const LoanEmployeeDetails = ({ employeeInfo, isLoanApproval = false }) => {
  return (
    <div className="d-flex mr-2">
      <div className="d-flex align-items-center mr-1">
        {!isEmpty(employeeInfo.imageURL) ? (
          <img
            alt=""
            src={employeeInfo.imageURL}
            style={{ width: "50px", height: "50px", borderRadius: "50%" }}
            className="img-fluid"
          />
        ) : (
          <GetInitials
            className={"ft-20 img-size"}
            name={
              employeeInfo?.employeeName ??
              fullName(
                employeeInfo?.firstName,
                employeeInfo?.middleName,
                employeeInfo?.lastName
              )
            }
          />
        )}
      </div>
      <div className="ml-2 w-75">
        <div className="ft-16 fw-500 m-0 p-0">
          <AddToolTip
            name={
              employeeInfo?.employeeName ??
              fullName(
                employeeInfo?.firstName,
                employeeInfo?.middleName,
                employeeInfo?.lastName
              )
            }
          />
        </div>
        <div
          className={`${
            isLoanApproval ? "approval-card-label" : ""
          } ft-14 fw-500 m-0 p-0`}
        >
          {ssnMasking(
            employeeInfo?.ssn ?? employeeInfo?.uniquePersonalIdentification
          )}
        </div>
        <div className="ft-14 fw-500 m-0 p-0 active-status">
          <FontAwesomeIcon
            icon={faCheckCircle}
            className="ft-12 mr-1 active-status"
          />
          {employeeInfo?.employmentStatus ?? employeeInfo?.employmentStatus}
        </div>
      </div>
    </div>
  );
};

export default LoanEmployeeDetails;
